import formatPrice from 'utils/formatPrice';
import { ICartProduct } from 'models';

import { useCart } from 'contexts/cart-context';


import * as S from './style';

interface IProps {
  product: ICartProduct;
}
const CartProduct = ({ product }: IProps) => {
  const { removeProduct, increaseProductQuantity, decreaseProductQuantity } = useCart();
  const {
    sku,
    title,
    price,
    style,
    currency_id,
    currency_format,
    available_types,
    quantity,
  } = product;

  const handleRemoveProduct = () => removeProduct(product);
  const handleIncreaseProductQuantity = () => increaseProductQuantity(product);
  const handleDecreaseProductQuantity = () => decreaseProductQuantity(product);

  return (
    <S.Container>
      <S.DeleteButton
        style={{ backgroundImage: `url(${process.env.REACT_APP_CDN_URL}delete-icon.png)` }}
        onClick={handleRemoveProduct}
        title="remove product from cart"
      />
      <S.Image
          src={`${process.env.PUBLIC_URL}/staticImg/${sku}-1-cart.jpg`}
        alt={title}
      />
      <S.Details>
        <S.Title>{title}</S.Title>
        <S.Desc>
          {`${JSON.parse(available_types)[0]} | ${style}`} <br />
          数量: {quantity}
        </S.Desc>
      </S.Details>
      <S.Price>
        <p>{`${currency_format}  ${formatPrice(price, currency_id)}`}</p>
        <div>
          <S.ChangeQuantity
            onClick={handleDecreaseProductQuantity}
            disabled={quantity === 1 ? true : false}
          >
            -
          </S.ChangeQuantity>
          <S.ChangeQuantity onClick={handleIncreaseProductQuantity}>
            +
          </S.ChangeQuantity>
        </div>
      </S.Price>
    </S.Container>
  );
};

export default CartProduct;
